import {
  Card,
  CardContent,
  Avatar,
  Typography,
  Button,
  Stack,
  Divider,
  Box,
} from "@mui/material"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { NavLink } from "react-router-dom"

const newRequests = [
  { id: 1, name: "John Doe", type: "Broker", avatar: "/placeholder.svg" },
  { id: 2, name: "Jane Smith", type: "Appraiser", avatar: "/placeholder.svg" },
  { id: 3, name: "Robert Johnson", type: "Lender", avatar: "/placeholder.svg" },
]
const textColor = "#0d2561";
export function NewConnectionsWidget() {
  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#0d2561" }}>
          New Connections Request
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          <strong style={{ color: textColor }}>{newRequests.length}</strong> requests pending
        </Typography>

        <Stack spacing={1.5}>
          {newRequests.map((request) => (
            <Box
              key={request.id}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center" gap={1.5}>
                <Avatar
                  src={request.avatar}
                  alt={request.name}
                  sx={{ width: 36, height: 36 }}
                />
                <Box>
                  <Typography variant="body2" fontWeight={500}>
                    {request.name}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ color: "text.secondary", fontSize: "0.75rem" }}
                  >
                    {request.type}
                  </Typography>
                </Box>
              </Box>

              <Button
                variant="outlined"
                size="small"
                sx={{
                  height: 36,
                  fontSize: "0.875rem",
                  textTransform: "none",
                  px: 2,
                  borderRadius: "6px",
                  borderColor: "#ccc", // mimics `border-input`
                  color: "#0d2561",
                  backgroundColor: "#fff",
                  "&:hover": {
                    backgroundColor: "#00838f", // light green hover (like Tailwind's bg-accent)
                    color: "#ffffff", // darker green text for contrast
                    borderColor: "#bcd0c7",
                  },
                }}
              >
                View
              </Button>
            </Box>
          ))}
        </Stack>


        <Box textAlign="right">
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              endIcon={<ArrowForwardIcon />}
              sx={{
                textTransform: "none",
                fontSize: "0.875rem",
                p: 0,
                minHeight: "auto",
                color: textColor
              }}
            >
              View all requests
            </Button>
          </NavLink>
        </Box>
      </CardContent>
    </Card>
  )
}
